export default __webpack_public_path__ + "static/media/free3.5eae7adf.svg";